import { RegEventListCards } from './RegEventListCards'
export default RegEventListCards